// React imports.
import React from "react";

//app imports
import {Assessment3VendorAssignedStatusEnum} from "../state";
import {Assessment3HHDataReceivedStatusEnum} from "../state";
import {Assessment3HHVendorsSelectedStatusEnum} from "../state";
import {Assessment3HHServedByVendorsProvidingDataStatusEnum} from "../state";
import {Assessment3RateOfReturnStatusEnum} from "../state";


const Assessment3Sup1TableRow = ({ state, fuel, rowClass  }) => (
    <React.Fragment>
      <div className={"dwGridRow col1 blue-background "+ rowClass} >{fuel.description}</div>
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&
            <div className={"dwGridRow col2 blue-background "+ rowClass} >
                <span className={"requiredDash"}>*</span><input required id="numHouseholds" value={fuel.numHouseholds }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsServedByVendorsSelected === true &&
            <div className={"dwGridRow col3 yellow-background "+ rowClass}>
                <span className={"requiredDash"}>*</span><input required id="numHouseholdsServedByVendorsSelected" value={fuel.numHouseholdsServedByVendorsSelected }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentHouseholdsServedByVendorsSelected === true &&
            <React.Fragment>
                {(fuel.householdsServedByVendorsSelectedStatus ===Assessment3HHVendorsSelectedStatusEnum.OverTargetNoIssues)
                    &&<div className={"dwGridRow col4 green-background "+ rowClass} >{fuel.percentHouseholdsServedByVendorsSelected}</div>
                }
                {(fuel.householdsServedByVendorsSelectedStatus ===Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget)
                    &&<div className={"dwGridRow col4 red-background "+ rowClass} >{fuel.percentHouseholdsServedByVendorsSelected}</div>
                }
            </React.Fragment>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showHouseholdsServedByVendorsSelectedStatus === true &&
            <React.Fragment>
                {(fuel.numHouseholdsServedByVendorsSelected ===null
                    || fuel.numHouseholdsServedByVendorsSelected === 0)
                    &&
                    <div className={"dwGridRow col5 red-background "+ rowClass} >
                        <span>
                            <strong>Potential Issue – </strong>
                            You did not report the number
                            of  {fuel.description}  households served by vendors
                            selected for data collection.
                        </span>
                    </div>
                }
                {(fuel.householdsServedByVendorsSelectedStatus === Assessment3HHVendorsSelectedStatusEnum.OverTargetNoIssues
                      &&fuel.numHouseholdsServedByVendorsSelected !== null
                      && fuel.numHouseholdsServedByVendorsSelected > 0)
                    &&
                    <div className={"dwGridRow col5 green-background "+ rowClass} >
                        <span>
                            <strong>No Issue Flagged –</strong>
                            At least  {fuel.targetPercentHouseholdsCoveredString}  of
                            your  {fuel.description}  households are served by vendors
                            from whom you requested data.
                        </span>
                    </div>
                }
                {(fuel.numHouseholdsServedByVendorsSelected > 0
                    && fuel.numHouseholdsServedByVendorsSelected !== null
                    && fuel.householdsServedByVendorsSelectedStatus ===Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget)
                    &&<div className={"dwGridRow col5 red-background "+ rowClass} >
                        <span>
                            <strong>Potential Issue –</strong>
                            The vendors from whom you requested data do NOT
                            serve at least  {fuel.targetPercentHouseholdsCoveredString}  of
                            your  {fuel.description}  households.
                        </span>
                      </div>
                }
            </React.Fragment>
        }






    </React.Fragment>
);

export default Assessment3Sup1TableRow;
